import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import type { ArticleSummary } from '@/lib/api/models';
import { formatDate } from '@/lib/utils/format';

export function ArticleCard({ article }: { article: ArticleSummary }) {
  return (
    <Card className="group overflow-hidden transition-shadow hover:shadow-[var(--shadow-elevated)]">
      <Link to={`/news/${article.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-surface-2">
          {article.featured_image_url ? (
            <img
              src={article.featured_image_url}
              alt=""
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="h-full w-full bg-gradient-to-br from-purple-50 to-pink-50" />
          )}
        </div>
        <div className="p-5">
          {article.published_at && (
            <time className="text-xs font-medium text-teal-600">
              {formatDate(article.published_at)}
            </time>
          )}
          <h3 className="mt-1 text-lg font-bold text-ink group-hover:text-purple-600">
            {article.title}
          </h3>
          {article.excerpt && (
            <p className="mt-2 line-clamp-2 text-sm text-muted">{article.excerpt}</p>
          )}
        </div>
      </Link>
    </Card>
  );
}
